import React from 'react';
import classNames from 'classnames';

import ErrorMessageServer from '../ErrorMessageServer';

import css from './styles.less';

import { ResponseErrorType } from '@/types/api';

interface Props {
  children?: React.ReactNode;
  styles?: React.CSSProperties;
  error?: ResponseErrorType;
  actionsClassName?: string;
  className?: string;
  wrapClassName?: string;
}

const ModalFooter = ({
  children,
  styles,
  error,
  actionsClassName = '',
  className = '',
  wrapClassName = '',
}: Props) => {
  const containerClassName = classNames(css.container, className);
  const wrapClass = classNames(css.wrapper, wrapClassName);
  return (
    <div className={containerClassName} style={styles}>
      <div className={wrapClass}>
        <div className={classNames(css.actions, actionsClassName)}>{children}</div>
        {error && (
          <div className={css.error}>
            <ErrorMessageServer error={error} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalFooter;
